if (!customElements.get('wiping-image')) {
  customElements.define(
    'wiping-image',
    class WipingImage extends HTMLElement {
      constructor() {
        super();
      }
    
      connectedCallback() {
        const updateHTML = (block) => {
          const message = this.querySelector('[data-message]');
          const button = this.querySelector('[data-button');
          const image_index = block.dataset.image;
          const headers = this.querySelectorAll('[data-header]');
  
          message.innerHTML = block.dataset.copy;
  
          if (block.dataset.cta && block.dataset.ctaLink) {
            button.innerHTML = block.dataset.cta;
            button.setAttribute('href', block.dataset.ctaLink);

            if (block.dataset.newTab === 'true') {
              button.setAttribute('target', '_blank');
              button.setAttribute('rel', 'noopener noreferrer');
            } else {
              button.removeAttribute('target');
              button.removeAttribute('rel');
            }

            button.classList.remove('hidden');
          } else {
            button.classList.add('hidden');
          }

          headers.forEach((header) => {
            const header_chevron = header.querySelector('[data-header-chevron]');
            
            if (header.dataset.header === image_index) {
              header.classList.remove('opacity-40');
              header.classList.add('opacity-100');
              header_chevron.classList.remove('hidden');
            } else {
              header.classList.add('opacity-40');
              header.classList.remove('opacity-100');
              header_chevron.classList.add('hidden');
            }
          });
        };

        const headers = this.querySelectorAll('[data-header]');

        headers.forEach((header) => {
          header.addEventListener('click', (ev) => {
            const current_active_image = this.querySelector('.image-active');
            const current_active_image_index = Number(current_active_image.dataset.image);
            const selected_index = Number(ev.target.dataset.header);
            const image_to_show = this.querySelector(`[data-image="${selected_index}"]`);

            if (current_active_image === image_to_show) return;

            if (selected_index > current_active_image_index) {
              current_active_image.classList.add('image-wipe-from-top');
              image_to_show.classList.add('image-active');

              updateHTML(image_to_show);

              setTimeout(() => {
                current_active_image.classList.remove('image-active');
                current_active_image.classList.remove('image-wipe-from-top');
              }, 150);
            } else {
              current_active_image.classList.add('image-wipe-from-bottom');
              image_to_show.classList.add('image-active');
              
              updateHTML(image_to_show);

              setTimeout(() => {
                current_active_image.classList.remove('image-active');
                current_active_image.classList.remove('image-wipe-from-bottom');
              }, 150);
            }
          });
        });

        const first_image = this.querySelector('[data-image="1"]');
        first_image.classList.add('image-active');
        updateHTML(first_image);
      }
    }
  )
}